import { render, staticRenderFns } from "./DataSearchWidget.vue?vue&type=template&id=2aded616&"
import script from "./DataSearchWidget.vue?vue&type=script&lang=ts&"
export * from "./DataSearchWidget.vue?vue&type=script&lang=ts&"
import style0 from "./DataSearchWidget.vue?vue&type=style&index=0&id=2aded616&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports